import React from 'react';
import {LauncherLayout} from "../../launcher/layout/LauncherLayout";
import {Card, Descriptions, List} from "antd";
import {launcherCard} from "../../launcher/common/styles";

export const PrivacyPolicy: React.FC = () => {
    return (
        <LauncherLayout disableNavigation={true} disableBackground={true}>
            <Card style={{...launcherCard}} title={<strong>Πολιτική Προστασίας Δεδομένων Προσωπικού Χαρακτήρα &amp; Απορρήτου</strong>}>
                <p><strong>Τελευταία ενημέρωση:</strong> [11/03/2026]<br /><strong>Ιστότοπος/Εφαρμογή κρατήσεων:</strong> <a href="https://reservations.therpglodge.com/">https://reservations.therpglodge.com/</a></p>
                <hr />
                <p><strong>1. Ποιοι είμαστε – Υπεύθυνος Επεξεργασίας</strong></p>
                <p>Υπεύθυνος Επεξεργασίας των προσωπικών δεδομένων είναι o <strong>ΤΣΙΡΚΙΝΙΔΗΣ ΒΑΣΙΛΕΙΟΣ</strong>, με έδρα <strong>ΚΟΥΝΤΟΥΡΙΩΤΟΥ 22, 55132, ΘΕΣΣΑΛΟΝΙΚΗ</strong>, ΑΦΜ <strong>150970206</strong>, ΔΟΥ <strong>ΚΑΛΑΜΑΡΙΑΣ</strong>.<br /><strong>Στοιχεία επικοινωνίας για θέματα απορρήτου:</strong></p>
                <ul>
                    <li>Email: <strong><a href="mailto:therpglodge@gmail.com">therpglodge@gmail.com</a></strong>  </li>
                    <li>Τηλέφωνο: <strong>+30 697 398 3914</strong>  </li>
                    <li>Ταχυδρομική διεύθυνση: <strong>ΚΟΥΝΤΟΥΡΙΩΤΟΥ 22, 55132, ΘΕΣΣΑΛΟΝΙΚΗ</strong></li>
                </ul>
                <hr />
                <p><strong>2. Τι δεδομένα συλλέγουμε</strong></p>
                <p>Ανάλογα με τη χρήση του ιστοτόπου/της εφαρμογής κρατήσεων, ενδέχεται να συλλέγουμε:</p>
                <p><strong>2.1 Δεδομένα για online κρατήσεις</strong></p>
                <ul>
                    <li><strong>Ονοματεπώνυμο</strong>  </li>
                    <li><strong>Στοιχεία επικοινωνίας</strong> (τηλέφωνο, email)  </li>
                    <li><strong>Στοιχεία κράτησης</strong> (ημερομηνία/ώρα, τύπος εκδήλωσης/πακέτου, αριθμός ατόμων, τυχόν σημειώσεις που συμπληρώνετε εσείς)  </li>
                    <li><strong>Ιστορικό επικοινωνίας</strong> σχετικά με την κράτηση (email/μηνύματα/τηλεφωνικές σημειώσεις)</li>
                </ul>
                <p><strong>2.2 Δεδομένα λογαριασμού χρήστη (αν ενεργοποιηθεί user account)</strong></p>
                <ul>
                    <li>Στοιχεία σύνδεσης (π.χ. email/username)  </li>
                    <li>Προτιμήσεις λογαριασμού (π.χ. γλώσσα, αγαπημένες επιλογές, ιστορικό κρατήσεων)</li>
                </ul>
                <p><strong>2.3 Τεχνικά δεδομένα &amp; δεδομένα χρήσης</strong></p>
                <ul>
                    <li>Διεύθυνση IP, αναγνωριστικά συσκευής/προγράμματος περιήγησης, ημερομηνία/ώρα πρόσβασης, logs, πληροφορίες ασφάλειας/αντι-κατάχρησης</li>
                </ul>
                <p><strong>2.4 Cookies &amp; παρόμοιες τεχνολογίες</strong></p>
                <ul>
                    <li>Cookies που είναι <strong>απαραίτητα</strong> για τη λειτουργία του site/της εφαρμογής κρατήσεων</li>
                </ul>
                <p><strong>2.5 Newsletter / Marketing (αν ενεργοποιηθεί)</strong></p>
                <ul>
                    <li>Email και προτιμήσεις επικοινωνίας (π.χ. θεματολογία)  </li>
                    <li>Καταγραφή συγκατάθεσης (πότε/πώς δόθηκε) και επιλογών opt-out</li>
                </ul>
                <p><strong>2.6 Social Media (αν ενσωματωθούν)</strong></p>
                <p>Αν υπάρχουν κουμπιά/ενσωματώσεις (plugins, pixels, embedded posts), ενδέχεται να διαβιβάζονται τεχνικά δεδομένα προς τις αντίστοιχες πλατφόρμες, ανάλογα με τις ρυθμίσεις σας και τη συγκατάθεση για cookies (βλ. ενότητα 12).</p>
                <hr />
                <p><strong>3. Για ποιους σκοπούς τα χρησιμοποιούμε – Νομικές βάσεις</strong></p>
                <p>Επεξεργαζόμαστε τα δεδομένα σας μόνο όταν υπάρχει νόμιμη βάση κατά GDPR και συναφή ελληνική νομοθεσία (ν. 4624/2019).</p>
                <p><strong>3.1 Εκτέλεση σύμβασης / παροχή υπηρεσίας (άρθρο 6(1)(β) GDPR)</strong></p>
                <ul>
                    <li>Καταχώρηση και διαχείριση <strong>online κρατήσεων</strong>  </li>
                    <li>Επικοινωνία μαζί σας για επιβεβαίωση/αλλαγές/ακυρώσεις  </li>
                    <li>Δημιουργία και διαχείριση <strong>λογαριασμού χρήστη</strong> (αν παρέχεται)</li>
                </ul>
                <p><strong>3.2 Έννομο συμφέρον (άρθρο 6(1)(στ) GDPR)</strong></p>
                <ul>
                    <li>Ασφάλεια συστημάτων, πρόληψη απάτης/κατάχρησης, λειτουργική παρακολούθηση (logs)  </li>
                    <li>Βελτίωση υπηρεσιών και εμπειρίας χρήστη (π.χ. συνολικά στατιστικά), <strong>μόνο</strong> στο μέτρο που δεν υπερισχύουν τα δικαιώματά σας</li>
                </ul>
                <p><strong>3.3 Συγκατάθεση (άρθρο 6(1)(α) GDPR)</strong></p>
                <ul>
                    <li>Newsletter / προωθητικές επικοινωνίες (όπου απαιτείται)  </li>
                    <li>Μη-απαραίτητα cookies (στατιστικά / διαφημιστικά κ.λπ.)</li>
                </ul>
                <p>Η συγκατάθεση για cookies απαιτείται κατά το εφαρμοστέο πλαίσιο για την αποθήκευση/πρόσβαση σε πληροφορίες στον τερματικό εξοπλισμό (ν. 3471/2006, ιδίως άρθρο 4 παρ. 5, όπως ισχύει). (<a href="https://www.dpa.gr/el/cookies/plirofories/whatis_cookies?utm_source=chatgpt.com">dpa.gr</a>)</p>
                <p><strong>3.4 Νομική υποχρέωση (άρθρο 6(1)(γ) GDPR)</strong></p>
                <ul>
                    <li>Τήρηση στοιχείων που απαιτούνται από φορολογική/λογιστική νομοθεσία (π.χ. τιμολόγηση/παραστατικά), όπου εφαρμόζεται.</li>
                </ul>
                <hr />
                <p><strong>4. Σε ποιους μπορεί να διαβιβάζονται τα δεδομένα (Αποδέκτες)</strong></p>
                <p>Τα δεδομένα σας μπορεί να κοινοποιούνται μόνο όταν είναι αναγκαίο, και ενδεικτικά σε:</p>
                <ul>
                    <li><strong>Πάροχοι φιλοξενίας (hosting), υποδομών, ασφάλειας</strong> (cloud/servers)  </li>
                    <li><strong>Πάροχοι email/SMS</strong> για αποστολή επιβεβαιώσεων (transactional) ή newsletter (marketing)  </li>
                    <li><strong>Λογιστής/φοροτεχνικός</strong> και λοιποί σύμβουλοι, όπου απαιτείται για συμμόρφωση  </li>
                    <li><strong>Αρχές/δικαστικές αρχές</strong> όταν αυτό επιβάλλεται από νόμο ή για θεμελίωση/άσκηση/υποστήριξη νομικών αξιώσεων</li>
                </ul>
                <p>Όλοι οι τρίτοι που ενεργούν “για λογαριασμό μας” δεσμεύονται ως <strong>εκτελούντες την επεξεργασία</strong> με κατάλληλες συμβάσεις και μέτρα ασφάλειας.</p>
                <hr />
                <p><strong>5. Διεθνείς διαβιβάσεις (εκτός ΕΟΧ)</strong></p>
                <p>Αν χρησιμοποιήσουμε παρόχους εκτός ΕΟΧ (π.χ. συγκεκριμένες πλατφόρμες email/analytics/ads), διασφαλίζουμε ότι υπάρχει νόμιμος μηχανισμός διαβίβασης (π.χ. απόφαση επάρκειας ή κατάλληλες εγγυήσεις όπως τυποποιημένες συμβατικές ρήτρες) και, όπου απαιτείται, πρόσθετα τεχνικά/οργανωτικά μέτρα.</p>
                <hr />
                <p><strong>6. Χρόνος τήρησης (Retention)</strong></p>
                <p>Τηρούμε τα δεδομένα μόνο για όσο απαιτείται για τον σκοπό που συλλέχθηκαν, σύμφωνα με την αρχή του περιορισμού της περιόδου αποθήκευσης. (<a href="https://commission.europa.eu/law/law-topic/data-protection/rules-business-and-organisations/principles-gdpr/how-long-can-data-be-kept-and-it-necessary-update-it_en?utm_source=chatgpt.com">European Commission</a>)</p>
                <p>Ενδεικτικά:</p>
                <ul>
                    <li><strong>Δεδομένα κράτησης/επικοινωνίας:</strong> για όσο χρειάζεται για εκτέλεση της υπηρεσίας και στη συνέχεια για εύλογο διάστημα για υποστήριξη/αντιρρήσεις/νομικές αξιώσεις.  </li>
                    <li><strong>Δεδομένα λογαριασμού:</strong> έως τη διαγραφή του λογαριασμού ή/και μετά από περίοδο αδράνειας <strong>5 έτη</strong>.  </li>
                    <li><strong>Λογιστικά/φορολογικά στοιχεία:</strong> για όσο προβλέπεται από την ισχύουσα φορολογική/λογιστική νομοθεσία.  </li>
                    <li><strong>Newsletter:</strong> μέχρι να ανακαλέσετε τη συγκατάθεσή σας (unsubscribe/opt-out).  </li>
                    <li><strong>Cookies:</strong> ανά κατηγορία, όπως ορίζεται στην ενότητα 10 και στις ρυθμίσεις cookies.</li>
                </ul>
                <hr />
                <p><strong>7. Τα δικαιώματά σας</strong></p>
                <p>Έχετε, κατά περίπτωση, τα δικαιώματα:</p>
                <ul>
                    <li><strong>Πρόσβασης</strong> στα δεδομένα σας  </li>
                    <li><strong>Διόρθωσης</strong> ανακριβών στοιχείων  </li>
                    <li><strong>Διαγραφής</strong> (“δικαίωμα στη λήθη”), όπου εφαρμόζεται  </li>
                    <li><strong>Περιορισμού</strong> της επεξεργασίας  </li>
                    <li><strong>Φορητότητας</strong> (όπου ισχύει, π.χ. σε δεδομένα που μας δώσατε με βάση σύμβαση/συγκατάθεση)  </li>
                    <li><strong>Εναντίωσης</strong> στην επεξεργασία που βασίζεται σε έννομο συμφέρον  </li>
                    <li><strong>Ανάκλησης συγκατάθεσης</strong> οποτεδήποτε (για επεξεργασίες που βασίζονται σε συγκατάθεση), χωρίς να θίγεται η νομιμότητα πριν από την ανάκληση</li>
                </ul>
                <p>Για άσκηση δικαιωμάτων: στείλτε αίτημα στο <strong><a href="mailto:therpglodge@gmail.com">therpglodge@gmail.com</a></strong> από το email που χρησιμοποιείτε στις κρατήσεις/στον λογαριασμό. Ενδέχεται να ζητήσουμε εύλογη επιβεβαίωση ταυτότητας.</p>
                <p><strong>Δικαίωμα καταγγελίας</strong></p>
                <p>Αν θεωρείτε ότι παραβιάζονται τα δικαιώματά σας, μπορείτε να υποβάλετε καταγγελία στην <strong>Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (ΑΠΔΠΧ)</strong> (Κηφισίας 1-3, 115 23 Αθήνα, τηλ. +30 210 6475600, email: <a href="mailto:contact@dpa.gr">contact@dpa.gr</a>). (<a href="https://www.dpa.gr/en/individuals/complaint-to-the-hellenic-dpa?utm_source=chatgpt.com">dpa.gr</a>)</p>
                <hr />
                <p><strong>8. Ασφάλεια</strong></p>
                <p>Λαμβάνουμε κατάλληλα τεχνικά και οργανωτικά μέτρα, όπως:</p>
                <ul>
                    <li>κρυπτογράφηση σε μεταφορά (TLS/HTTPS),  </li>
                    <li>έλεγχοι πρόσβασης και περιορισμός δικαιωμάτων,  </li>
                    <li>καταγραφή συμβάντων (logs) για ασφάλεια,  </li>
                    <li>αντίγραφα ασφαλείας και διαδικασίες αποκατάστασης,  </li>
                    <li>τακτικές ενημερώσεις/διορθώσεις λογισμικού.</li>
                </ul>
                <hr />
                <p><strong>9. Αυτοματοποιημένη λήψη αποφάσεων / profiling</strong></p>
                <p>Δεν λαμβάνουμε αποφάσεις που παράγουν έννομα αποτελέσματα για εσάς αποκλειστικά με αυτοματοποιημένη επεξεργασία.</p>
                <hr />
                <p><strong>10. Πολιτική Cookies &amp; Ρυθμίσεις</strong></p>
                <p>Χρησιμοποιούμε cookies και παρόμοιες τεχνολογίες:</p>
                <ul>
                    <li>για να λειτουργεί σωστά ο ιστότοπος/η εφαρμογή κρατήσεων,  </li>
                    <li>(προαιρετικά) για στατιστικά/βελτιστοποίηση,  </li>
                    <li>(προαιρετικά) για διαφημίσεις/remarketing,  </li>
                    <li>(προαιρετικά) για λειτουργίες social media.</li>
                </ul>
                <p>Η εγκατάσταση μη-απαραίτητων cookies γίνεται <strong>μόνο</strong> μετά από ενημέρωση και συγκατάθεση, σύμφωνα με το ισχύον πλαίσιο (ν. 3471/2006, άρθρο 4 παρ. 5). (<a href="https://www.dpa.gr/el/cookies/plirofories/whatis_cookies?utm_source=chatgpt.com">dpa.gr</a>)</p>
                <p><strong>10.1 Κατηγορίες cookies (παράδειγμα)</strong></p>
                <ol>
                    <li><strong>Απαραίτητα (Strictly Necessary):</strong> σύνδεση, ασφάλεια, session, βασικές λειτουργίες κράτησης.  </li>
                    <li><strong>Προτιμήσεων:</strong> αποθήκευση επιλογών (π.χ. γλώσσα).  </li>
                    <li><strong>Στατιστικών/Ανάλυσης:</strong> μέτρηση επισκεψιμότητας/συμπεριφοράς (π.χ. analytics).</li>
                </ol>
                <p><strong>10.2 Διαχείριση συγκατάθεσης</strong></p>
                <p>Κατά την πρώτη επίσκεψη εμφανίζεται (ή πρέπει να εμφανίζεται) <strong>banner/εργαλείο ρυθμίσεων cookies</strong>, όπου μπορείτε να:</p>
                <ul>
                    <li>αποδεχθείτε όλα,  </li>
                    <li>απορρίψετε τα μη-απαραίτητα,  </li>
                    <li>επιλέξετε ανά κατηγορία.</li>
                </ul>
                <p>Μπορείτε επίσης να αλλάξετε ρυθμίσεις από τις ρυθμίσεις του browser σας.</p>
                <p><strong>Συμπλήρωση (υποχρεωτική στην πράξη):</strong> Προσθέστε εδώ έναν πίνακα με <strong>το πραγματικό cookie inventory</strong> (όνομα cookie, πάροχος, διάρκεια, κατηγορία, σκοπός).</p>
                <p>Αναλυτικός πίνακας με τα απαραίτητα cookies για την λειτουργία της εφαρμογής:</p>
                <List
                    dataSource={[
                        {
                            name: 'g_state',
                            provider: 'reservations.therpglodge.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Διαχείριση συνεδρίας στον περιηγητή',
                        },
                        {
                            name: 'JSESSIONID',
                            provider: 'reservations.therpglodge.com',
                            duration: 'Δυναμική με βάση τη συνεδρία στο διακομιστή',
                            category: 'Απαραίτητα',
                            purpose: 'Διαχείριση συνεδρίας στον περιηγητή',
                        },
                        {
                            name: 'rcl_consent_given',
                            provider: 'reservations.therpglodge.com',
                            duration: '13 μήνες',
                            category: 'Προτιμήσεων',
                            purpose: 'Διαχείριση προτιμήσεων για cookies στον περιηγητή',
                        },
                        {
                            name: 'ACCOUNT_CHOOSER',
                            provider: 'accounts.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: 'APISID',
                            provider: '.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: 'HSID',
                            provider: '.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: 'LSID',
                            provider: 'accounts.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: 'NID',
                            provider: '.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: 'OTZ',
                            provider: 'accounts.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: 'SAPISID',
                            provider: '.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: 'SID',
                            provider: '.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: 'SIDCC',
                            provider: '.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: 'SMSV',
                            provider: 'accounts.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: 'SSID',
                            provider: '.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: '__Host-1PLSID',
                            provider: 'accounts.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: '__Host-3PLSID',
                            provider: 'accounts.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: '__Host-GAPS',
                            provider: 'accounts.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: '__Secure-1PAPISID',
                            provider: '.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: '__Secure-1PSID',
                            provider: '.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: '__Secure-1PSIDCC',
                            provider: '.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: '__Secure-3PAPISID',
                            provider: '.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: '__Secure-3PSID',
                            provider: '.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: '__Secure-3PSIDCC',
                            provider: '.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        },
                        {
                            name: '__Secure-ENID',
                            provider: '.google.com',
                            duration: '13 μήνες',
                            category: 'Απαραίτητα',
                            purpose: 'Ενσωμάτωση αυθεντικοποίησης μέσω λογαριασμού Google',
                        }
                    ]}
                    renderItem={(item) =>
                        <List.Item>
                            <Descriptions bordered style={{marginBottom: '3px'}}>
                                <Descriptions.Item label={'Όνομα cookie'}>{item["name"]}</Descriptions.Item>
                                <Descriptions.Item label={'Πάροχος'}>{item["provider"]}</Descriptions.Item>
                                <Descriptions.Item label={'Διάρκεια'}>{item["duration"]}</Descriptions.Item>
                                <Descriptions.Item label={'Κατηγορία'}>{item["category"]}</Descriptions.Item>
                                <Descriptions.Item label={'Σκοπός'}>{item["purpose"]}</Descriptions.Item>
                            </Descriptions>
                        </List.Item>
                    }
                />
                <hr />
                <p><strong>11. Newsletter / Προωθητικές επικοινωνίες</strong></p>
                <p>Αν εγγραφείτε σε newsletter:</p>
                <ul>
                    <li>Θα σας στέλνουμε ενημερωτικό/προωθητικό περιεχόμενο μόνο σύμφωνα με τη βάση που εφαρμόζεται (συνήθως <strong>συγκατάθεση</strong>).  </li>
                    <li>Μπορείτε να διαγραφείτε οποτεδήποτε μέσω του link <strong>unsubscribe</strong> σε κάθε email ή επικοινωνώντας στο <strong><a href="mailto:therpglodge@gmail.com">therpglodge@gmail.com</a></strong>.  </li>
                    <li>Διατηρούμε τεκμηρίωση της συγκατάθεσης και του opt-out για λόγους συμμόρφωσης.</li>
                </ul>
                <hr />
                <p><strong>12. Social Media</strong></p>
                <p>Αν ο ιστότοπος ενσωματώνει λειτουργίες/περιεχόμενο τρίτων (π.χ. embedded posts, pixels, share buttons), οι τρίτοι πάροχοι μπορεί να συλλέγουν δεδομένα (π.χ. cookies/αναγνωριστικά). Για τα μη-απαραίτητα trackers ζητείται συγκατάθεση μέσω των ρυθμίσεων cookies (ενότητα 10).</p>
                <p>Πολιτική απορρήτου Google: <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a> </p>
                <hr />
                <p><strong>13. Επικοινωνία</strong></p>
                <p>Για οποιαδήποτε απορία σχετικά με την παρούσα πολιτική ή την επεξεργασία δεδομένων:<br /><strong>Email:</strong> <a href="mailto:therpglodge@gmail.com">therpglodge@gmail.com</a> | <strong>Τηλ.:</strong> +30 697 398 3914 | <strong>Διεύθυνση:</strong> Κουντουριώτου 22, Θεσσαλονίκη, 55132</p>
                <hr />
                <p><strong>14. Αλλαγές στην παρούσα Πολιτική</strong></p>
                <p>Ενδέχεται να τροποποιούμε την παρούσα πολιτική (π.χ. αν αλλάξουν υπηρεσίες, πάροχοι ή απαιτήσεις συμμόρφωσης). Η πιο πρόσφατη έκδοση θα είναι πάντα διαθέσιμη στον ιστότοπο με ενημερωμένη ημερομηνία “Τελευταίας ενημέρωσης”.</p>
                <hr />
            </Card>
        </LauncherLayout>
    );
}